module.exports = __webpack_public_path__ + "static/media/github.d93f0bd0.png";